import {
  getOptionAvailableUnits,
  getProductAvailableUnits,
} from "@faire/retailer-visitor-shared/lib/product";
import { getProductDetails } from "@faire/retailer-visitor-shared/views/product/utils/productUtils";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { IProductOption } from "@faire/web-api--source/indigofair/data/IProductOption";
import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";

const MAX_AVAILABLE_UNITS_TO_SHOW = 10;

export const shouldShowAvailableUnits = (
  product: IProductPageResponse.IPdpProduct,
  availableUnits: number,
  selectedOption?: IProductOption
): boolean => {
  const selectedOptionAvailable = selectedOption
    ? selectedOption.state === IProduct.State.FOR_SALE
    : true;

  // Disabling this for open sizing - it doesn't really make sense to show
  return (
    availableUnits > 0 &&
    availableUnits <= MAX_AVAILABLE_UNITS_TO_SHOW &&
    !product.purchase_information?.per_style_min_order_quantity &&
    product.state === IProduct.State.FOR_SALE &&
    selectedOptionAvailable
  );
};

export const getAvailableUnits = (
  product: IProductPageResponse.IPdpProduct,
  selectedOption?: IProductOption
): number =>
  selectedOption === undefined
    ? getProductAvailableUnits(getProductDetails(product))
    : getOptionAvailableUnits(getProductDetails(product), selectedOption);
